enum Role {
  ADMINISTRATOR = 'ADMINISTRATOR',
  APAVE_CONTRACTOR_LIFTING = 'APAVE_CONTRACTOR_LIFTING',
  DEKRA_CONTRACTOR_LIFTING = 'DEKRA_CONTRACTOR_LIFTING',
  VERITAS_CONTRACTOR_LIFTING = 'VERITAS_CONTRACTOR_LIFTING',
  DEKRA_CONTRACTOR_ELECTRICAL = 'DEKRA_CONTRACTOR_ELECTRICAL',
  VERITAS_CONTRACTOR_ELECTRICAL = 'VERITAS_CONTRACTOR_ELECTRICAL',
  APAVE_CONTRACTOR_ELECTRICAL = 'APAVE_CONTRACTOR_ELECTRICAL',
  EN_EL_INSPECTOR_ELECTRICAL = 'EN_EL_INSPECTOR_ELECTRICAL',
  SY_INSPECTOR_ELECTRICAL = 'SY_INSPECTOR_ELECTRICAL',
  SY_CONTRACTOR_ELECTRICAL = 'SY_CONTRACTOR_ELECTRICAL',
  INSPECTOR_LIFTING = 'INSPECTOR_LIFTING',
  INSPECTOR_ELECTRICAL = 'INSPECTOR_ELECTRICAL',
  INSPECTOR_MANAGER_LIFTING = 'INSPECTOR_MANAGER_LIFTING',
  INSPECTOR_MANAGER_ELECTRICAL = 'INSPECTOR_MANAGER_ELECTRICAL',
}

export default Role;
